// tslint:disable
export enum TCSDocumentType {
    /**
     * @description None
     */
    None = 0,
    /**
     * @description Claim
     */
    Claim = 1,
    /**
     * @description Correspondence
     */
    Correspondence = 2,
}
(TCSDocumentType as any)['NONE'] = 0;
(TCSDocumentType as any)['CLAIM'] = 1;
(TCSDocumentType as any)['CORRESPONDENCE'] = 2;
